import Skeleton from '@/common/components/skeleton/Skeleton';
import useImageLoader from '@/common/hooks/useImage';
import { getMediaDirectSrc } from '../../utils/getMediaFileId';
import { StoryPeek, StoryPeekSkeleton } from '../../StoryViewer.styles';

const StoryViewerPeek = ({ item, onClick, ariaLabel, hidden = false }) => {
	const previewMediaId = item?.previewMediaId ?? null;
	const directSrc = getMediaDirectSrc(item?.media);
	const { imageSrc, isLoading } = useImageLoader(previewMediaId);
	const resolvedSrc = imageSrc || directSrc;
	const showSkeleton = Boolean(previewMediaId) && (isLoading || !resolvedSrc);
	const position = item?.position || '50% 50%';
	const scale = item?.scale || 1;

	return (
		<StoryPeek
			type="button"
			onClick={onClick}
			aria-label={ariaLabel}
			$hidden={hidden}
		>
			{showSkeleton && (
				<StoryPeekSkeleton>
					<Skeleton
						width="100%"
						height="100%"
						radius="0"
						minWidth="100%"
						minHeight="100%"
					/>
				</StoryPeekSkeleton>
			)}
			{resolvedSrc && (
				<img
					src={resolvedSrc}
					alt=""
					style={{
						objectPosition: position,
						transform: `scale(${scale})`,
					}}
				/>
			)}
		</StoryPeek>
	);
};

export default StoryViewerPeek;
